import React, { useState } from "react";
import Logo from "../img/logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="w-full sticky top-0 z-[1000] bg-[#f1f3f3] text-blue-900 shadow-md">
      <div className="container mx-auto flex items-start justify-between mt-0 px-4 md:px-6 py-2 relative">
        {/* Logo + Mobile Menu */}
        <Link to="/" className="flex items-center">
          <label
            htmlFor="menu-toggle"
            className="cursor-pointer md:hidden block"
            onClick={toggleMenu}
          >
            <svg
              className="fill-current text-blue-900"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 20 20"
            >
              <title>menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
            </svg>
          </label>
          <img src={Logo} alt="BEQAEB Logo" className="w-32 ml-3" />
        </Link>

        {/* Mobile Sign In Button */}
        <div className={`md:hidden ${menuOpen ? "hidden" : "block"} pt-2`}>
          <Link to="/signin">
            <button className="bg-gradient-to-r from-blue-700 to-blue-900 text-white font-medium px-4 py-2 rounded-lg shadow-md hover:opacity-90 transition duration-200">
              Sign In
            </button>
          </Link>
        </div>

        {/* Navigation */}
        <div
          className={`md:flex md:items-center ${menuOpen ? "block" : "hidden"}`}
          id="menu"
        >
          <nav className="mr-4">
            <ul className="md:flex items-center justify-between text-base pt-4 md:pt-0">
              <Link
                to="/"
                className="inline-block no-underline hover:underline font-semibold text-lg py-2 px-4 lg:-ml-2"
              >
                Home
              </Link>

              {/* Accreditation Dropdown */}
              <li className="relative group">
                <button className="inline-block no-underline hover:underline font-semibold text-lg py-2 px-4 lg:-ml-2">
                  Accreditation
                </button>
                <div className="absolute left-0 top-full hidden group-hover:block w-64 bg-white text-gray-900 shadow-2xl rounded-lg border border-gray-200 z-[1100]">
                  <div className="flex flex-col p-2">
                    <a
                      href="/media/pdf/AN UPDATE OF UNAPPROVED SCHOOLS.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      List of Unapproved Private Schools
                    </a>
                    <a
                      href="/media/pdf/CERTIFICATE OF CONSENT (1ST BATCH).pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      List of Private Schools with Full Approval
                    </a>
                    <a
                      href="/media/pdf/SUMMARY FOR WASSCE AND NECO-1.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      2024 WASSCE/NECO: Data of Schools Accredited
                    </a>
                  </div>
                </div>
              </li>

              {/* Executives */}
              <li>
                <a
                  href="#executives"
                  className="inline-block no-underline hover:underline font-semibold text-lg py-2 px-4 lg:-ml-2"
                >
                  Executives
                </a>
              </li>

              {/* Media Dropdown */}
              <li className="relative group">
                <button className="inline-block no-underline hover:underline font-semibold text-lg py-2 px-4 lg:-ml-2">
                  Media
                </button>
                <div className="absolute left-0 top-full hidden group-hover:block w-64 bg-white text-gray-900 shadow-2xl rounded-lg border border-gray-200 z-[1100]">
                  <div className="flex flex-col p-2">
                    <a
                      href="/media/pdf/Academic-Calender-2023-2024-05.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      Academic Calendar 2023-2024
                    </a>
                    <a
                      href="/media/pdf/SSCE-Clerance-Guide-2024.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      S.S.C.E Clearance Guide 2024
                    </a>
                    <a
                      href="/media/pdf/PRE-PRIMARY PRIMARY SCHOOL.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      Pre-Primary School
                    </a>
                    <a
                      href="/media/pdf/PRIVATE JUNIOR SECONDARY SCHOOL.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      Private Junior Secondary School
                    </a>
                    <a
                      href="/media/pdf/PRIVATE SENIOR SECONDARY SCHOOL.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm hover:bg-gray-100 rounded"
                    >
                      Private Senior Secondary School
                    </a>
                  </div>
                </div>
              </li>

              {/* Mobile Sign In */}
              <li className="block md:hidden px-4">
                <Link to="/signin">
                  <button className="bg-gradient-to-r from-blue-700 to-blue-900 text-white font-medium px-4 py-2 rounded-lg shadow-md hover:opacity-90 transition duration-200 w-full">
                    Sign In
                  </button>
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Desktop Sign In */}
        <div className="hidden md:flex order-2 md:order-3 items-center justify-end">
          <Link to="/signin">
            <button className="bg-gradient-to-r from-blue-700 to-blue-900 text-white font-medium px-5 py-2 mt-3 rounded-lg shadow-md hover:opacity-90 transition duration-200">
              Sign In
            </button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
